'use client'

import { displayBobDrawerAtom } from '@/feature/product/services/product.store'
import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import {
  GetProductAnomaliesDocument,
  ProductBob_CurrentUserPermissionsShowbobDocument,
} from '@gql-generated/graphql'
import { useSetAtom } from 'jotai'

gql(/* GraphQL */ `
  query GetProductAnomalies {
    productAnomalies {
      name
      value
      categories {
        name
        value
      }
    }
  }
`)

gql(/* GraphQL */ `
  query ProductBob_CurrentUserPermissionsShowbob {
    currentUser {
      id
      permissions {
        showBob
      }
    }
  }
`)

export function BobButton() {
  const setIsDrawerOpen = useSetAtom(displayBobDrawerAtom)
  const { t } = useTranslation(['productPage'])

  const { data: currentUserPermissionsShowBob, loading: permissionsLoading } = useQuery(
    ProductBob_CurrentUserPermissionsShowbobDocument,
    APOLLO_CLIENT_SIDE_OPTIONS,
  )

  const { data: productAnomaliesData, loading: anomaliesLoading } = useQuery(
    GetProductAnomaliesDocument,
    APOLLO_CLIENT_SIDE_OPTIONS,
  )

  const isShowBob = !!currentUserPermissionsShowBob?.currentUser?.permissions?.showBob

  if (
    permissionsLoading ||
    anomaliesLoading ||
    !isShowBob ||
    !productAnomaliesData?.productAnomalies?.length
  ) {
    return null
  }

  return (
    <Button
      className="border-[--color-carrot-orange-600] bg-[--color-carrot-orange-600] data-[hovered]:border-[--color-carrot-orange-600] data-[hovered]:bg-[--color-carrot-orange-600]"
      variant="tertiary"
      isRound
      size="sm"
      onPress={() => {
        pushToGtmDataLayer({
          event: 'gaEvent',
          eventCategory: 'fiche article / produit',
          eventAction: 'bouton bob',
          eventLabel: 'clic',
        })
        setIsDrawerOpen(true)
      }}
      iconLeft={<Icon.Wrench />}
    >
      {t('productPage:bob.label')}
    </Button>
  )
}
